import { RepairTypeResource as Res } from '@shared/resources/repair-type';
import { RepairTypeCreateUpdateDto as DTO } from '@shared/dto/repair-type';
import { CrudService } from './crud.service';

export class RepairTypesService extends CrudService<DTO, DTO, Res> {
  protected pathPrefix(): string {
    return 'repair-types';
  }
}
